module.exports = __webpack_public_path__ + "img/value-beknowledgeable.b48a7f6a.svg";